// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__R6e3X","text":"Logo_text__PNXyR","icon":"Logo_icon__v3BJg","textBold":"Logo_textBold__QJNln"};